import _ from 'underscore';

import EventEmitter from 'js/vendor/EventEmitter';

import submissionSummariesPromise from 'bundles/programming/promises/submissionSummaries';

// These code blocks look like they're out of order, but they actually don't work if you fix the order.

function onLoadSuccess(submissionSummaries: $TSFixMe) {
  submissionSummariesStore.submissionSummaries = submissionSummaries;
  submissionSummariesStore.emit('update', submissionSummaries);
}

function onLoadError(error: $TSFixMe) {
  submissionSummariesStore.error = error;
  submissionSummariesStore.emit('updateError', error);
}

function SubmissionSummariesStore() {
  // @ts-expect-error TSMIGRATION
  this.submissionSummaries = null;
}

SubmissionSummariesStore.prototype = _.extend({}, EventEmitter.prototype, {
  load({ itemId, itemTypeName, courseId, courseSlug, userId }: $TSFixMe) {
    submissionSummariesPromise({ itemId, itemTypeName, courseId, courseSlug, userId }).then(onLoadSuccess, onLoadError);
  },
});

// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
const submissionSummariesStore = new SubmissionSummariesStore();

export default submissionSummariesStore;
